<template>
  <div class="sample-database-sidebar">
    <BackButton :clickMethod="back" class="mb-3"/>
    <h4>
      {{$tI('Advanced reports')}} | <br/>
       {{$tI('Sample Database')}}
    </h4>

    <p class="description mt-2">
      {{ $tI('Database of samples Subtitle') }}
    </p>

    <div class="search mb-4 mt-4">
      <b-form-input class="d-inline-block mr-1" size="md" :placeholder="$tI_G('Search by population box')" 
        v-model="$store.state.sampleDatabase.filterQuery.Search" @input="changeSearch"/>
    </div>

    <SampleTypeDropdown />
    <LocationsDropdown class="mt-4" v-if="selectedSampleType !== 'MODERN'"/>
  </div>
</template>

<script>
import communicationService from '@/services/PostMessageCommunation/CommunicationService';
import dataKeys from '@/services/PostMessageCommunation/enums/DataKeys';

import BackButton from '@/components/ui/BackButton.vue';
import SampleTypeDropdown from './SampleTypeDropdown.vue';
import LocationsDropdown from './LocationsDropdown.vue';

export default {
  components: {
    BackButton,
    SampleTypeDropdown,
    LocationsDropdown,
  },
  data() {
    return {
      sampleTypeList: [
        {
          id: 'ANCIENT',
          title: 'Ancient (Population)',
        },
        {
          id: 'MODERN',
          title: 'Modern (Population)',
        },
        {
          id: 'ANCIENT-INDIVIDUAL',
          title: 'Ancient (Individual)',
        },
      ],
    };
  },
  methods: {
    back() {
      this.$router.push({ name: 'dashboard' });
    },
    changeSearch() {
      this.$store.state.sampleDatabase.filterQuery.PageIndex = 1;

      communicationService.sendDataToParent({
        key: dataKeys.STATISTICS,
        value: 'Iframe.ancientDnaSampleDatabaseSearch',
      });
    },
  },
  computed: {
    selectedSampleType() {
      return this.$store.state.sampleDatabase.selectedSampleType;
    },
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>
.sample-database-sidebar {
  box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
  padding: 28px;
  height: 100%;
  background-color: var(--white-100);
}

</style>